import PropTypes from "prop-types"
import React from "react"

import * as style from "./team-tile.module.scss"

const TeamTile = ({ image, name, role, chapter, about }) => {
  console.log(chapter);

  return (
  <div className={style.teamTile}>
    <div className={`content`}>
      <div
        className={style.image}
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: `cover`,
          backgroundPosition: `center center`,
          backgroundColor: `rgba(0,0,0,.1)`,
        }}
      ></div>
      <h4>{name}</h4>
      <h5>{role}</h5>
      {chapter && <h6 className={`letter-spaced-heading`}>{chapter}</h6>}
      <p>{about}</p>
    </div>
  </div>
)}

TeamTile.propTypes = {
  image: PropTypes.element,
  name: PropTypes.string,
  about: PropTypes.string,
  role: PropTypes.string,
  chapter: PropTypes.string,
}

TeamTile.defaultProps = {
  name: ``,
  about: ``,
  role: ``,
  chapter: ``,
}

export default TeamTile